import { createApp } from '@app/adapters/create-app'

import ReportGraphEditor from '../screens/graph-editor/components/graph-editor'
import createStore from '../screens/graph-editor/store/index'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='report-graph-editor']").each(function () {
    const store = createStore(JSON.parse(this.dataset.props))

    const graphEditorApp = createApp(ReportGraphEditor)
    graphEditorApp.use(store)
    graphEditorApp.mount(this)
  })
})
